/**
 * Callback nguồn
 */
export default {
  /**
   * Không xác định
   */
  None: 0,

  /**
   * Model
   */
  Model: 1,

  /**
   * Event chung
   */
  Event: 2,
};
